import { useMemo, useState } from "react";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

export default function Simulator() {
  const [inicial, setInicial] = useState("");
  const [mensal, setMensal] = useState("");
  const [anos, setAnos] = useState(10);
  const [taxa, setTaxa] = useState(10); // % ao ano

  const { data, total, aportes, juros } = useMemo(() => {
    const inicialN = parseFloat(String(inicial).replace(",", ".")) || 0;
    const mensalN = parseFloat(String(mensal).replace(",", ".")) || 0;
    const monthlyRate = Math.pow(1 + taxa / 100, 1 / 12) - 1;
    const months = anos * 12;
    let balance = inicialN;
    let totalAportes = inicialN;
    const data = [{ ano: 0, valor: inicialN, aportes: inicialN }];
    for (let m = 1; m <= months; m++) {
      balance = balance * (1 + monthlyRate) + mensalN;
      totalAportes += mensalN;
      if (m % 12 === 0) {
        data.push({ ano: m / 12, valor: Math.round(balance), aportes: Math.round(totalAportes) });
      }
    }
    return { data, total: Math.round(balance), aportes: Math.round(totalAportes), juros: Math.round(balance - totalAportes) };
  }, [inicial, mensal, anos, taxa]);

  const fmt = (v) => `R$ ${v.toLocaleString('pt-BR')}`;

  return (
    <div data-testid="simulator" className="grid md:grid-cols-12 gap-6">
      <div className="md:col-span-4 brutal-card">
        <h2 className="font-bebas text-3xl tracking-tighter">Bora simular</h2>
        <p className="text-white/60 font-manrope text-sm mt-1">Vê o poder dos juros compostos.</p>

        <div className="mt-6 space-y-5">
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Valor inicial (R$)</label>
            <input data-testid="sim-inicial" type="text" inputMode="decimal" value={inicial} onChange={e=>setInicial(e.target.value)} placeholder="Ex: 1000" className="brutal-input mt-2"/>
          </div>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Aporte mensal (R$)</label>
            <input data-testid="sim-mensal" type="text" inputMode="decimal" value={mensal} onChange={e=>setMensal(e.target.value)} placeholder="Ex: 500" className="brutal-input mt-2"/>
          </div>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Anos: {anos}</label>
            <input data-testid="sim-anos" type="range" min="1" max="40" value={anos} onChange={e=>setAnos(+e.target.value)} className="w-full accent-[#CCFF00]"/>
          </div>
          <div>
            <label className="font-manrope text-xs uppercase tracking-widest text-white/60">Rentabilidade ano: {taxa}%</label>
            <input data-testid="sim-taxa" type="range" min="1" max="20" step="0.5" value={taxa} onChange={e=>setTaxa(+e.target.value)} className="w-full accent-[#CCFF00]"/>
          </div>
        </div>
      </div>

      <div className="md:col-span-8 space-y-4">
        <div className="grid grid-cols-3 gap-4">
          <div className="brutal-card" style={{borderColor:'#CCFF00'}}>
            <div className="font-manrope text-xs uppercase tracking-widest text-white/50">Total final</div>
            <div className="font-bebas text-3xl md:text-4xl text-[#CCFF00] mt-2 break-all">{fmt(total)}</div>
          </div>
          <div className="brutal-card">
            <div className="font-manrope text-xs uppercase tracking-widest text-white/50">Aportes</div>
            <div className="font-bebas text-3xl md:text-4xl mt-2 break-all">{fmt(aportes)}</div>
          </div>
          <div className="brutal-card" style={{borderColor:'#00F0FF'}}>
            <div className="font-manrope text-xs uppercase tracking-widest text-white/50">Juros</div>
            <div className="font-bebas text-3xl md:text-4xl text-[#00F0FF] mt-2 break-all">{fmt(juros)}</div>
          </div>
        </div>

        <div className="brutal-card" style={{height: 380}}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{top: 10, right: 10, left: 0, bottom: 10}}>
              <CartesianGrid strokeDasharray="3 3" stroke="#222"/>
              <XAxis dataKey="ano" stroke="#666" tick={{fill:'#999', fontFamily:'Manrope'}} label={{value:'anos', position:'insideBottomRight', fill:'#666'}}/>
              <YAxis stroke="#666" tick={{fill:'#999', fontFamily:'Manrope'}}/>
              <Tooltip contentStyle={{background:'#0A0A0A', border:'2px solid #CCFF00', borderRadius:0, fontFamily:'Manrope'}} formatter={(v)=>fmt(v)}/>
              <Line type="linear" dataKey="valor" stroke="#CCFF00" strokeWidth={3} dot={false}/>
              <Line type="linear" dataKey="aportes" stroke="#FF0055" strokeWidth={2} strokeDasharray="4 4" dot={false}/>
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
